import { BitkitLink, IconDownload } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { chakra } from '@chakra-ui/react/styled-system';
import { Text } from '@chakra-ui/react/text';
import { MouseEventHandler } from 'react';

import { trackTestAttachmentDownloadButtonClicked } from '@/components/test-results/TestResults.tracking';

import { Attachment } from '../../../../TestResults.types';
import { FileType } from '../AttachmentsTab.types';
import { downloadAttachment, getMimeType } from '../AttachmentsTab.utils';

const MediaAttachment = ({ url, type, fileName }: Attachment & { type: FileType; fileName: string }) => {
  if (!['video', 'image'].includes(type)) {
    return null;
  }

  const handleDownload: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault();
    downloadAttachment(url, fileName);
    trackTestAttachmentDownloadButtonClicked({ attachmentType: type, attachmentFileName: fileName });
  };

  return (
    <Box display="flex" flexDir="column">
      {type === 'video' && (
        <video controls>
          <source src={url} type={getMimeType(fileName)} />
          <track kind="captions" />
          Your browser does not support the video tag.
        </video>
      )}
      {type === 'image' && <chakra.img objectFit="contain" objectPosition="top center" src={url} alt={fileName} />}
      <Text textStyle="body/sm/regular" mt="4" wordBreak="break-all">
        {fileName}
      </Text>
      <BitkitLink
        colorVariant="purple"
        href={url}
        download={fileName}
        isExternal
        marginTop="8"
        suffixIcon={IconDownload}
        suffixIconSize="16"
        onClick={handleDownload}
      >
        Download
      </BitkitLink>
    </Box>
  );
};

export default MediaAttachment;
